export default {
    transform() {
        return (data) =>
            JSON.parse(data).map((option) => ({
                value: option.id,
                label: `${option.firstName} ${option.lastName}`,
                data: option,
            }))
    },
}
